/*** IMPORTS FROM imports-loader ***/
var define = false;

/*** IMPORTS FROM imports-loader ***/


'use strict';

const Logger = require('../logger');
const Confirm = require('./components/confirm');
const Modal = require('./components/modal');

class DialogFactory {

  createConfirmDialog(global, message) {
    return new Confirm(global, message);
  }

  createModalDialog(global, message) {
    return new Modal(global, message);
  }

  static create() {
    Logger.sendLog('window dialog factory create');
    return new DialogFactory();
  }

}

module.exports = DialogFactory;




/*** EXPORTS FROM exports-loader ***/



/** WEBPACK FOOTER **
 ** ./service/dialog_factory.js
 **/